function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.308 47.671c-3.121-6.197-2.806-17.235-2.545-21.512 4.937-.338 8.487-1.273 8.487-2.375 0-1.082-3.417-2.003-8.211-2.357a9.498 9.498 0 005.156-8.448c0-5.248-4.252-9.501-9.5-9.501s-9.5 4.253-9.5 9.501a9.5 9.5 0 005.156 8.448c-4.793.354-8.212 1.275-8.212 2.357 0 1.102 3.552 2.037 8.488 2.375.262 4.278.577 15.316-2.544 21.512-6.118 1.23-10.411 4.117-10.411 7.48h34.045c0-3.363-4.287-6.251-10.405-7.483z",
  stroke: "#000",
  strokeWidth: 0.65721672,
  strokeLinejoin: "round"
});

function SvgBlackPawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgBlackPawn;